import React from 'react'
import { modals, modalConfigurations } from 'components/Modal/configurations'
import { connect } from 'react-redux'
import { updateUiAction } from 'actions/uiActions'
import style from './style'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { modalTitleSelector } from 'selectors/components'

function mapStateToProps(state) {
  const { ui: { modal, offlineTimeLimit }, locked, messages } = state

  return {
    modal,
    locked,
    offlineTimeLimit,
    messages,
    modalTitle: modalTitleSelector(state)
  }
}

class Modal extends React.Component {
  constructor(props) {
    super(props)

    this.skipClick = false
    if (props.modal) {
      this.ChildComponent = modals[props.modal]
      this.config = modalConfigurations[`${props.modal}Config`] || {}
    }
  }

  close = _ => {
    this.props.updateUiAction({ modal: null, deviceLimitType: null })
  }

  closeModelOnEscapeKeydown = e => {
    if (!this.props.modal || this.props.locked || !this.showClose()) return
    e.key === 'Escape' && this.close()
  }

  closeModalOnWindowClick = e => {
    if (!this.props.modal || this.props.locked || !this.showClose() || this.skipClick || this.refs.container.contains(e.target)) {
      this.skipClick = false
      return
    }

    this.skipClick = false
    this.close()
  }

  skipListener = _ => this.skipClick = true

  componentDidMount = _ => {
    document.addEventListener('keydown', this.closeModelOnEscapeKeydown)
    document.addEventListener('click', this.closeModalOnWindowClick, true)
  }

  componentWillUnmount = _ => {
    document.removeEventListener('keydown', this.closeModelOnEscapeKeydown)
    document.removeEventListener('click', this.closeModalOnWindowClick, true)
  }

  componentWillUpdate = ({ modal }) => {
    this.ChildComponent = modals[modal]
    this.config = modalConfigurations[`${modal}Config`] || {}
  }

  showClose = _ => {
    const { config, props: { modal, offlineTimeLimit } } = this

    return !config.hideClose && !(modal === 'LoginForm' && offlineTimeLimit)
  }

  render() {
    const { ChildComponent, close, config, skipListener, showClose, props: { modal, modalTitle, messages, classes } } = this

    if (!modal) return null

    return (
      <div className={classes.modal}>
        <div
          className={classes.container}
          style={{ width: config.width || '90%', maxWidth: config.width || '600px' }}
          onMouseDown={skipListener}
          onTouchStart={skipListener}
          ref='container'
        >
          <div className={classes.header}>
            <span className={classes.title}>{modalTitle}</span>
            { showClose() && <FontAwesomeIcon icon='times' onClick={close} className={classes.close} /> }
            { modal === 'DoorControllerDesigner' && !!messages && <span className={classes.saveMessage}>{messages.saveState}</span> }
          </div>
          <div className={classes.body}>
            <ChildComponent close={close} />
          </div>
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps, { updateUiAction })(injectSheet(style)(Modal))



// WEBPACK FOOTER //
// ./src/components/Modal/index.js